import { createSelector } from 'reselect';

const domain = (state) => state;

export const selectPopupStatus = () => createSelector(
    domain,
    substate => substate.isPopupShow
)